/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ComponentDebug = (props) => {

    const component = props?.component;
    const field = props?.field;
    const name = field?.name;

    return (
        <div
            style={{
                border: "1px solid #0980B5", backgroundColor: "#0980B522",
                padding: "24px", minHeight: "120px", minWidth: "100%",
                display: "flex", flexDirection: "column",
                justifyContent: "center", alignItems: "center",
            }}
        >
            <div>{name}</div>
            <div>{component.type}</div>
            <div>
                <details
                    style={{
                        display: "flex", flexDirection: "column",
                        justifyContent: "center", alignItems: "center"
                    }}
                >
                    <summary
                        style={{
                            padding: "4px 12px", marginTop: "12px", backgroundColor: "#0980B5",
                            color: "white", borderRadius: "100vw", width: "200px",
                            display: "flex", justifyContent: "center", alignItems: "center"
                        }}
                    >
                        <b>Component JSON</b>
                    </summary>
                    <pre style={{ marginTop: "12px", backgroundColor: "white", overflow: "scroll", fontSize: "10px", overflowY: "auto", border: "1px solid #343434", height: "250px", maxWidth: "680px" }}>
                        {JSON.stringify(component,null,4)}
                    </pre>
                </details>
            </div>
        </div>
    );
};

ComponentDebug.displayName = "ComponentDebug";
export { ComponentDebug };
